import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { InfraEntities } from "../InfraEntities";
import { InfraLayout } from '../InfraLayout';
import { InfraRouterProps } from "../InfraRouterProps";
import EnvironmentList from "../components/EnvironmentList";
import { NSSpace, NSSpaceSizeType } from "namirasoft-site-react";

interface ProjectViewPageProps extends NSARouterMakerResult, InfraRouterProps { }

export default class ProjectViewPage extends Component<ProjectViewPageProps>
{
    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={{
                    entity: InfraEntities.project(this.props),
                    view: {
                        ui: {
                            getChildrenAfter: (id) => (
                                <>
                                    <NSSpace size={NSSpaceSizeType.MINI} />
                                    <EnvironmentList {...this.props} project_id={id} />
                                </>
                            )
                        }
                    }
                }}
            >
                <></>
            </InfraLayout>
        );
    }
}